module.exports = __webpack_public_path__ + "static/media/drum-machine.03d8f1a5.jpg";